import {trans} from '@frontend/helpers'
import {
    AsyncDataLoading as AsyncDataLoadingBase,
    type AsyncDataLoadingProps,
} from 'swayok-react-mdb-ui-kit/components/Loading/AsyncDataLoading'

interface Props<DataType = undefined> extends Omit<AsyncDataLoadingProps<DataType>, 'errorMessage' | 'retryButtonTitle'> {
    errorMessage?: string | null | undefined
    retryButtonTitle?: string | null | undefined
}

// Показывает индикатор загрузки данных пока не загрузятся данные.
// Если загрузка не удалась (error), то отображает ошибку (errorMessage)
// с кнопкой перезагрузки данных (retryButtonTitle, onReload).
export function AsyncDataLoading<DataType = undefined>(props: Props<DataType>) {
    const {
        errorMessage,
        retryButtonTitle,
        ...otherProps
    } = props
    return (
        <AsyncDataLoadingBase<DataType>
            {...otherProps}
            errorMessage={errorMessage ?? trans().common.async_data_loading.data_loading_error}
            retryButtonTitle={retryButtonTitle ?? trans().common.async_data_loading.retry_after_error}
        />
    )
}
